import { userPasswordTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const userPasswordCreate = (state = defaultState, action) =>
  commonReducer(actionTypes.CREATE, state, action);

export const userPasswordUpdate = (state = defaultState, action) =>
  commonReducer(actionTypes.UPDATE, state, action);
